import React, { useState } from 'react';
import { TextButton } from 'components/v2/buttons';
import TextWithAnimatedEllipsis from 'components/v2/file-upload/TextWithAnimatedEllipsis';
import { HelpBox } from 'components/v2/help-boxes';
import FontIcon from 'components/icons/FontIcon';
import { FieldPanelFullWidth, FieldPanelHeader } from 'styles/v2/Styles.styled';
import { DocumentActionState } from 'types/dynamic-forms/DocumentModelStateActions';
import { getDocumentIlcdEpdBundle } from 'services/api/dynamicFormsApi';
import { downloadIlcdEpdBundle } from 'util/downloadlcdEpdByAdmin';
import { useDocumentStore } from '../hooks/useDocumentStore';

const IlcdEpdBundlePanelRenderer: React.FC<any> = () => {
  const { docId, state } = useDocumentStore();
  // Local on purpose: useDocumentActions().isSpinnerVisible is shared by every Dynamic Forms action button.
  const [isLoading, setIsLoading] = useState<boolean>(false);

  if (state?.actions?.downloadIlcdEpdBundle !== DocumentActionState.Enabled) {
    return null;
  }

  const handleDownload = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      // The route takes the document head id; the server builds the bundle from the head's current version.
      await downloadIlcdEpdBundle(() => getDocumentIlcdEpdBundle(docId));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FieldPanelFullWidth>
      <FieldPanelHeader>ILCD+EPD</FieldPanelHeader>
      <div>
        <HelpBox>
          You can download ILCD+EPD bundle and check it in the validation tool before approving the EPD publication.
        </HelpBox>
        <TextButton
          type="button"
          label="Download ILCD+EPD"
          icon={<FontIcon icon="download" style={{ fontSize: 16, lineHeight: 1 }} />}
          text
          disabled={isLoading}
          onClick={handleDownload}
        />
        {isLoading && <TextWithAnimatedEllipsis>Generating bundle</TextWithAnimatedEllipsis>}
      </div>
    </FieldPanelFullWidth>
  );
};

export default IlcdEpdBundlePanelRenderer;
